import styled from 'styled-components';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

export const ButtonSubmit = styled(Button)`
  margin: 30px 0 0 0;
`;

export const FormRow = styled(Form.Row)`
  margin: 0;
  width: 492px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100% !important;
`;